import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../Footer/Footer';

// import brandw from '../assets/images/brandsw.png';
import weserve_industries from '../assets/images/weserve_industries.png'
import Getintouch from '../Gettouch/Getintouch';
// import Productslide from '../ProductSection/Productslide';
// for slick-slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import wesersd1 from '../assets/images/weserveslider2.png';
import wesersd2 from '../assets/images/weserveslider1.png';
import wesersd3 from '../assets/images/weserveslider2.png';
import wesersd4 from '../assets/images/weserveslider1.png'

import Slider from "react-slick";
import TextBanner from './TextBanner';
import imageUrl from '../assets/images/industrieswe.png';

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow:3,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

var settings2 = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: { 
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 700,
      settings: { 
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

// for slick-slider end 



const Weserve = () => {
  return (
    <>

    {/* new banner dynamic */}

        <TextBanner
          imageUrl={imageUrl}
          altname="Industries We Serve"
          title="We speak your industry's language digitally."  
        />
      {/*  new banner dynamic end */}


      <section className='whoslider pt-0'>
        <Container>
          <Row>
            <Col lg={12}>
              <Slider {...settings}>
                <div>
                <img src={wesersd1} alt="Slide1" />
                </div>
                <div>
                <img src={wesersd2} alt="Slide1" />
                </div>
                <div>
                <img src={wesersd3} alt="Slide1" />
                </div>
                <div>
                <img src={wesersd4} alt="Slide1" />
                </div>
               
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>


        {/* text only */}

        <section className='textpara'>
          <Container>
            <Row>
              <Col lg={12}>
                <p>Every business has a unique story, and every industry has its own digital landscape. At RedCube Digital Media, we believe in crafting tailored strategies that ignite growth, regardless of your field. We're proud to partner with businesses in:  </p>

              </Col>
              {/* <Col lg={12} className='text-center p-lg-5 p-3' >
                <img src={redoffice} alt="office" />
              </Col> */}
              
            </Row>
          </Container>
        </section>

        {/* Building Brands & Driving Leads */}

        <section className='buildingbrand'>
          <Container>
            <Row >
              <Col md={12}>
                <h2 className='text-center'>Building Brands & Driving Leads </h2>
                
                <div className='buildBox'>
                  <ul>
                    <li>
                      <h4>E-commerce:</h4>
                      <p>We help online stores convert browsers into buyers, maximizing sales and brand loyalty.</p>
                    </li>
                    <li>
                      <h4>SaaS & Technology:</h4>
                      <p>We amplify your reach, attracting new users and driving adoption through targeted digital campaigns.</p>
                    </li>
                    <li>
                      <h4>Professional Services:</h4>
                      <p>We showcase your expertise and build trust, establishing your firm as the go-to leader.</p>
                    </li>
                    <li>
                      <h4>Consumer Products:</h4>
                      <p>We create captivating experiences that connect with your audience and drive sales.</p>
                    </li>
                    <li>
                      <h4>Hospitality & Tourism:</h4>
                      <p>We bring destinations to life, attracting travelers and boosting bookings.</p>
                    </li>          
                  </ul>          
                </div>
              </Col>
            </Row>
          </Container>
        </section>


        {/* Building Brands & Driving Leads end */}

        {/* slider section */}

        <section className='buildslide'>     
          <h2 className='text-center p-3'> Reaching New Heights & Building Communities </h2>

          <Container>
          <Row>
            <Col lg={12}>
              <Slider {...settings2}>
                <div>
                <img src={wesersd1} alt="Slide1" />
                </div>
                <div>
                <img src={wesersd2} alt="Slide1" />
                </div>
                <div>
                <img src={wesersd3} alt="Slide1" />
                </div>
                <div>
                <img src={wesersd4} alt="Slide1" />
                </div>
               
              </Slider>
            </Col>
          </Row>
        </Container>
          
        </section>



        {/* slider section end*/}







      <section className='textpara2'>
        <Container>
          <Row>            
            <Col lg={11} className='m-auto text-center p-lg-5 p-3' >
              <img src={weserve_industries} alt="Beyond the Industries" />
            </Col>
            <Col lg={11} className='m-auto'>
              <h2>Beyond the Industries: </h2>
              <p>This isn't an exhaustive list. We believe every business deserves to thrive online, and we're passionate about uncovering your unique digital potential. Whether you're a startup disrupting your field or a seasoned player seeking new heights, we're here to partner with you on your journey. </p>
              <h5> Ready to unlock your digital potential? Get in touch today, and let's discuss how we can tailor a strategy that fuels your growth and ignites your brand in your industry. </h5>
            </Col>
          </Row>
        </Container>
      </section>




      {/* get in touch */}
      <section className='p-0'>
        <Getintouch />
      </section>


      {/* Footer  */}
      <section className='p-0'>
        <Footer />
      </section>
    </>
  );
};

export default Weserve;